var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHand1({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "Iconz/hand1"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M10.974 5.418C10.862 4.614 10.24 4 9.488 4h-.002c-.83.001-1.502.753-1.501 1.679.007 6.556.006 9.333-.002 9.331-1.378 0-2.421-2.953-4.23-2.953-1.81 0-2.113 1.073-1.39 2.023.482.633 5.62 7.92 5.62 7.92H16a4 4 0 0 0 4-4V8.68C20 7.752 19.326 7 18.495 7h-.001c-.83.001-1.502.753-1.501 1.679l-.002 4.331m-6.017-7.592c.012.085.018.172.018.26m-.018-.26-.001 7.592m.001-7.592v-1.74c0-.925.672-1.677 1.502-1.678h.001c.831 0 1.505.752 1.505 1.679l.002 2m0 0v7.331m0-7.332c-.001-.926.67-1.677 1.5-1.678h.002c.831 0 1.505.752 1.505 1.679v3",
    className: "iconz"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHand1);
export default __webpack_public_path__ + "static/media/hand1.6dd1fa73f5d02b967918b5483c7add59.svg";
export { ForwardRef as ReactComponent };